import { render, staticRenderFns } from "./NewProductModal.vue?vue&type=template&id=1d50bbd7&"
import script from "./NewProductModal.vue?vue&type=script&lang=js&"
export * from "./NewProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports